<template>
  <div class="loyalty-step">
    <h4 class="heading">{{ item.heading }}</h4>
    <Picture class="image" :images="item.images" />
    <div class="text">{{ item.text }}</div>
  </div>
</template>

<script>
import Picture from "@/components/Picture.vue";
export default {
  name: "LoyaltyStep",
  components: {
    Picture,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.loyalty-step {
  background-color: $color-light;
  margin: 0 auto;
  max-width: 400px;
  padding: 60px 10px 25px;
  text-align: center;

  @include respond-above(md) {
    padding: 60px 20px 25px;
  }
}

.heading {
  color: $color-dark;
  font-family: $heading-font-family;
  font-size: 28px;
  font-weight: 400;
  margin: -80px 0 20px 0;
  text-transform: uppercase;

  @include respond-above(md) {
    font-size: 50px;
    margin: -95px 0 20px 0;
  }
}
.image {
  display: block;
  margin: 0 0 20px 0;
}

.text {
  color: $color-dark;
  font-size: 13px;
  padding: 0 10px;

  @include respond-above(md) {
    font-size: 14px;
  }
}
</style>
